<div class="ft-input-toggle" [class.-editing]="isEditMode" [class.-disabled]="disabled">
    <div class="ft-input-toggle_content">
        <span #textElement class="ft-input-toggle_text ft-input-toggle_text--hidden">
            {{ value || placeholder }}
        </span>
        <input #inputElement
               [style.width]="inputWidth + 'px'"
               [class.-animated]="animated"
               type="text"
               class="ft-input-toggle_input"
               [placeholder]="placeholder"
               [value]="value"
               (focus)="onInputFocus()"
               (input)="onInputChange($event)"
               (blur)="onInputBlur()"
               [disabled]="disabled" />
        <button
            type="button"
            class="ft-input-toggle_edit-btn"
            [class.-active]="isEditMode"
            (click)="inputElement.focus();"
            [attr.aria-label]="isEditMode ? 'Done' : 'Edit'">
            <mat-icon svgIcon="ft-icn-pencil-outline"></mat-icon>
        </button>
    </div>
</div>
<br>
